import * as Sentry from '@sentry/browser';

// Init?
let dsn = document?.documentElement?.getAttribute('data-sentry-dsn');

if (dsn) {
    Sentry.init({
        dsn,
    });
}
